import axios from "axios";
// const url = process.env.REACT_APP_API_URI;

export const blockedInsuranceService = (data) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/IPD/insurance/open`);
  };
